<div #waveformContainer class="w-full h-8 flex items-center justify-center">
  <canvas #canvas [width]="canvasWidth" [height]="canvasHeight" class="w-full"></canvas>
</div>
